/* tslint:disable */
/* eslint-disable */
/**
 * Torrents Stream Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Log
 */
export interface Log {
    /**
     *
     * @type {string}
     * @memberof Log
     */
    message: string
    /**
     *
     * @type {number}
     * @memberof Log
     */
    time: number
    /**
     *
     * @type {string}
     * @memberof Log
     */
    level: LogLevelEnum
}

/**
 * @export
 * @enum {string}
 */
export enum LogLevelEnum {
    Debug = 'debug',
    Info = 'info',
    Warn = 'warn',
    Error = 'error',
}

export function LogFromJSON(json: any): Log {
    return LogFromJSONTyped(json, false)
}

export function LogFromJSONTyped(json: any, ignoreDiscriminator: boolean): Log {
    if (json === undefined || json === null) {
        return json
    }
    return {
        message: json['message'],
        time: json['time'],
        level: json['level'],
    }
}

export function LogToJSON(value?: Log | null): any {
    if (value === undefined) {
        return undefined
    }
    if (value === null) {
        return null
    }
    return {
        message: value.message,
        time: value.time,
        level: value.level,
    }
}
